var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeafletMap',{ref:"leafletMap",attrs:{"zoom":_vm.zoom,"center":_vm.coordinates,"bounds":_vm.bounds}},[_c('LMarker',{ref:"marker",attrs:{"lat-lng":_vm.coordinates,"icon":_vm.icon,"draggable":_vm.markerDraggable},on:{"dragend":_vm.onMarkerDragEnd}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }